export const locale = {
  lang: 'vn',
  data: {
    ERROR: {
      HTTP: {
        404: {
          'TITLE': '404 ERROR',
          'MESSAGE': 'Lỗi không tìm thấy trang'
        },
      },
    },
  },
};
